<template>
  <roe-error-message :field="design.employer_other_funding_frequency">
    <v-select
      v-model="design.$model.employer_other_funding_frequency"
      :disabled="design.$model.profit_sharing_allocation_method === 3"
      name="employer_other_funding_frequency"
      :options="selectOptions.funding_frequency"
      :reduce="label => label.code"
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapGetters } from "vuex";

export default {
  name: "RoeEmployerOtherFundingFrequencySelect",
  components: { RoeErrorMessage },
  props: {
    design: Object
  },
  computed: {
    ...mapGetters(["selectOptions"])
  }
};
</script>
